import React, { useState } from "react";
import {
  DialogActions,
  Button,
  List,
  ListItem,
  Box,
  Typography,
} from "@mui/material";
import FormTextField from "../ui/FormTextField";

function AttributesListModal({
  onClose,
  attributes,
  setAttributes,
  onEditVariations,
}) {
  const [newAttrName, setNewAttrName] = useState("");

  const handleAddAttribute = () => {
    if (!newAttrName.trim()) return;
    setAttributes((prev) => [...prev, { name: newAttrName, variations: [] }]);
    setNewAttrName("");
  };

  return (
    <>
      <Typography variant="h6" sx={{ mb: 1 }}>
        Додавання атрибуту
      </Typography>
      <Box sx={{ mb: 2, borderRadius: "15px" }}>
        <FormTextField
          label="Назва атрибута"
          value={newAttrName}
          onChange={(e) => setNewAttrName(e.target.value)}
          fullWidth
          margin="normal"
        />

        <DialogActions sx={{ justifyContent: "start", p: 0, mt: 2, mb: 6 }}>
          <Button
            variant="contained"
            sx={{ borderRadius: "15px", textTransform: "none" }}
            onClick={handleAddAttribute}
          >
            <Typography style={{ color: "white" }} variant="subtitle2">
              Додати атрибут
            </Typography>
          </Button>
          <Button
            onClick={onClose}
            sx={{ borderRadius: "15px", textTransform: "none" }}
          >
            Закрити
          </Button>
        </DialogActions>
      </Box>
      {/* Прозрачный блок-разделитель */}

      <List>
        {attributes.map((attr, idx) => (
          <ListItem
            className={`border-bottom ${idx === 0 ? "border-top" : ""}`}
            key={idx}
            onClick={() => {
              onClose();
              onEditVariations(idx);
            }}
            sx={{
              display: "flex",

              justifyContent: "space-between",
              cursor: "pointer",
              borderRadius: "15px",
              marginTop: "10px",
              overflow: "hidden",
              "& .MuiListItemButton-root": {
                borderRadius: "15px",
              },
            }}
          >
            <Typography variant="subtitle2">{attr.name} </Typography>{" "}
            <Typography variant="subtitle2">
              {attr.variations.length}
            </Typography>
          </ListItem>
        ))}
      </List>
    </>
  );
}

export default AttributesListModal;
